<template>
  <el-dialog
    title="Test Report Detail"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="1200px"
    @close="closeDialog()"
    class="test-report-detail"
  >
    <el-form
      label-width="90px"
      size="mini"
      :model="form"
      ref="form"
      v-loading="loading"
      id="print"
    >
      <div class="title" style="text-align: center; display: none">
        <b>{{ printInfo.popTitle }}</b>
      </div>
      <div class="total-time-line">
        Total Time: {{ totalTime | secondFormat }}
      </div>
      <div v-if="form.accelerometer_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            ACCELEROMETER CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.accelerometer_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Ax">
              <pre class="pre-input">{{ form.accelerometer_check.Ax }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Ay">
              <pre class="pre-input">{{ form.accelerometer_check.Ay }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Az">
              <pre class="pre-input">{{ form.accelerometer_check.Az }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="R">
              <pre class="pre-input">{{ form.accelerometer_check.R }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arx">
              <pre class="pre-input">{{ form.accelerometer_check.arx }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Ary">
              <pre class="pre-input">{{ form.accelerometer_check.ary }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arz">
              <pre class="pre-input">{{ form.accelerometer_check.arz }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.accelerometer_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.accelerometer_check.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 12 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.accelerometer_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.accelerometer_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.accelerometer_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.acc_verify">
        <div class="desc-wrapper">
          <span class="desc-info">
            ACC VERIFY
          </span>
          <span class="helper-info"
            >Total Time: {{ form.acc_verify.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arx">
              <pre class="pre-input">{{ form.acc_verify.arx }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Ary">
              <pre class="pre-input">{{ form.acc_verify.ary }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arz">
              <pre class="pre-input">{{ form.acc_verify.arz }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.acc_verify.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.acc_verify.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 12 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.acc_verify.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.acc_verify.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.acc_verify.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.accelerometer_calibration">
        <div class="desc-wrapper">
          <span class="desc-info">
            ACCELEROMETER CALIBRATION
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.accelerometer_calibration.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arx">
              <pre class="pre-input">{{
                form.accelerometer_calibration.arx
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Ary">
              <pre class="pre-input">{{
                form.accelerometer_calibration.ary
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Arz">
              <pre class="pre-input">{{
                form.accelerometer_calibration.arz
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.accelerometer_calibration.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.accelerometer_calibration.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 12 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.accelerometer_calibration.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.accelerometer_calibration.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="AccOffset">
              <pre class="pre-input">{{
                form.accelerometer_calibration.accOffSet
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{
                form.accelerometer_calibration.output
              }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.battery_level_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            BATTERY LEVEL CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.battery_level_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Battery Level">
              <pre class="pre-input">{{
                form.battery_level_check.battery_level
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.battery_level_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.battery_level_check.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.battery_level_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.battery_level_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.battery_level_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.ble_payload_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            BLE PAYLOAD CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.ble_payload_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Manf. ID">
              <pre class="pre-input">{{
                form.ble_payload_check.manufacture_id
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Packet Size">
              <pre class="pre-input">{{
                form.ble_payload_check.packet_size
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.ble_payload_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.ble_payload_check.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.ble_payload_check.output }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 18 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.ble_payload_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.ble_payload_check.result }}</pre
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.ble_rssi_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            BLE RSSI CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.ble_rssi_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Rssi">
              <pre class="pre-input">{{ form.ble_rssi_check.rssi }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.ble_rssi_check.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.ble_rssi_check.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.ble_rssi_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.ble_rssi_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.ble_rssi_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.capacitance_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            CAPACITANCE CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.capacitance_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC1 Check">
              <pre class="pre-input">{{
                form.capacitance_check.rc1_check
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC1 Gain">
              <pre class="pre-input">{{ form.capacitance_check.rc1_gain }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC1 Offset">
              <pre class="pre-input">{{
                form.capacitance_check.rc1_offset
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="RC1 External">
              <div class="pre-input">
                {{ form.capacitance_check.rc1_external }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="RC1 Internal">
              <div class="pre-input">
                {{ form.capacitance_check.rc1_internal }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC2 Check">
              <pre class="pre-input">{{
                form.capacitance_check.rc2_check
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC2 Gain">
              <pre class="pre-input">{{ form.capacitance_check.rc2_gain }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-form-item label="RC2 Offset">
              <pre class="pre-input">{{
                form.capacitance_check.rc2_offset
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="RC2 External">
              <div class="pre-input">
                {{ form.capacitance_check.rc2_external }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="RC2 Internal">
              <div class="pre-input">
                {{ form.capacitance_check.rc2_internal }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.capacitance_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.capacitance_check.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 6 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.capacitance_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.capacitance_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.capacitance_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.current_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            CURRENT CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.current_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Current (avg)">
              <pre class="pre-input">{{ form.current_check.current_avg }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.current_check.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.current_check.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.current_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.current_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.current_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.fall_detection">
        <div class="desc-wrapper">
          <span class="desc-info">
            FALL DETECTION
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.fall_detection.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.fall_detection.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.fall_detection.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 6 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.fall_detection.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.fall_detection.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.fall_detection.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.fw_burn">
        <div class="desc-wrapper">
          <span class="desc-info">
            FW BURN
          </span>
          <span class="helper-info"
            >Total Time: {{ form.fw_burn.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="HW Version">
              <pre class="pre-input">{{ form.fw_burn.hw_version }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="FW Version">
              <pre class="pre-input">{{ form.fw_burn.fw_version }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.fw_burn.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.fw_burn.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.fw_burn.output }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 18 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.fw_burn.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.fw_burn.result }}</pre
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.led_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            LED CHECK
          </span>
          <span class="helper-info"
            >Total Time: {{ form.led_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Green Led">
              <pre class="pre-input">{{ form.led_check.green_led }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Red Led">
              <pre class="pre-input">{{ form.led_check.red_led }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Led Brightness">
              <pre class="pre-input">{{ form.led_check.led_brightness }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.led_check.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.led_check.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 12 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.led_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.led_check.result }}</pre
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.led_check.output }}</pre>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.production_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            PRODUCTION CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.production_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Manf. ID">
              <pre class="pre-input">{{
                form.production_check.manufacture_id
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Packet Size">
              <pre class="pre-input">{{
                form.production_check.packet_size
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.production_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.production_check.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.production_check.output }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 18 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.production_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.production_check.result }}</pre
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.temperature_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            TEMPERATURE CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.temperature_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="Pod Temp">
              <pre class="pre-input">{{ form.temperature_check.pod_temp }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Temperature">
              <pre class="pre-input">{{
                form.temperature_check.temperature
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{
                form.temperature_check.start_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{
                form.temperature_check.stop_time
              }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.temperature_check.output }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 18 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.temperature_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.temperature_check.result }}</pre
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="form.voltage_check">
        <div class="desc-wrapper">
          <span class="desc-info">
            VOLTAGE CHECK
          </span>
          <span class="helper-info"
            >Total Time:
            {{ form.voltage_check.total_time | secondFormat }}</span
          >
        </div>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP3">
              <pre class="pre-input">{{ form.voltage_check.TP3 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP5">
              <pre class="pre-input">{{ form.voltage_check.TP5 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP9">
              <pre class="pre-input">{{ form.voltage_check.TP9 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP10">
              <pre class="pre-input">{{ form.voltage_check.TP10 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP33">
              <pre class="pre-input">{{ form.voltage_check.TP33 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="TP34">
              <pre class="pre-input">{{ form.voltage_check.TP34 }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Start Time">
              <pre class="pre-input">{{ form.voltage_check.start_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6">
            <el-form-item label="Stop Time">
              <pre class="pre-input">{{ form.voltage_check.stop_time }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="Output">
              <pre class="pre-input">{{ form.voltage_check.output }}</pre>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="{ span: 6, offset: 18 }">
            <el-form-item label="Result">
              <pre
                class="pre-input"
                :class="
                  form.voltage_check.result === this.pass
                    ? 'pass-input'
                    : 'failed-input'
                "
                >{{ form.voltage_check.result }}</pre
              >
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel-btn min-w-80" @click="share()">SHARE</el-button>
      <el-button class="cancel-btn min-w-80" v-print="printInfo"
        >PRINT</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()"
        >CLOSE</el-button
      >
    </span>
    <ShareDialog ref="shareDialog" />
  </el-dialog>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import { pass } from '../../../const'
import ShareDialog from './ShareDialog'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      form: {},
      pass: pass,
      loading: false,
      printInfo: {
        id: 'print',
        popTitle: ''
      },
      totalTime: 0
    }
  },
  components: {
    ShareDialog
  },
  methods: {
    openDialog(id) {
      this.dialogVisible = true
      this.id = id
      this.getDetail(id)
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getDetail(id) {
      this.loading = true
      ApiService.GetTestDetail(id)
        .then(response => {
          this.loading = false
          let data = response.data
          this.totalTime = 0
          this.form = data.electrical || data.functional || {}
          if (this.form.accelerometer_check) {
            this.form.accelerometer_check.total_time = moment(
              this.form.accelerometer_check.stop_time
            ).diff(moment(this.form.accelerometer_check.start_time), 'seconds')
            this.totalTime += this.form.accelerometer_check.total_time
          }
          if (this.form.battery_level_check) {
            this.form.battery_level_check.total_time = moment(
              this.form.battery_level_check.stop_time
            ).diff(moment(this.form.battery_level_check.start_time), 'seconds')
            this.totalTime += this.form.battery_level_check.total_time
          }
          if (this.form.ble_payload_check) {
            this.form.ble_payload_check.total_time = moment(
              this.form.ble_payload_check.stop_time
            ).diff(moment(this.form.ble_payload_check.start_time), 'seconds')
            this.totalTime += this.form.ble_payload_check.total_time
          }
          if (this.form.ble_rssi_check) {
            this.form.ble_rssi_check.total_time = moment(
              this.form.ble_rssi_check.stop_time
            ).diff(moment(this.form.ble_rssi_check.start_time), 'seconds')
            this.totalTime += this.form.ble_rssi_check.total_time
          }
          if (this.form.capacitance_check) {
            this.form.capacitance_check.total_time = moment(
              this.form.capacitance_check.stop_time
            ).diff(moment(this.form.capacitance_check.start_time), 'seconds')
            this.totalTime += this.form.capacitance_check.total_time
          }
          if (this.form.current_check) {
            this.form.current_check.total_time = moment(
              this.form.current_check.stop_time
            ).diff(moment(this.form.current_check.start_time), 'seconds')
            this.totalTime += this.form.current_check.total_time
          }
          if (this.form.fw_burn) {
            this.form.fw_burn.total_time = moment(
              this.form.fw_burn.stop_time
            ).diff(moment(this.form.fw_burn.start_time), 'seconds')
            this.totalTime += this.form.fw_burn.total_time
          }
          if (this.form.led_check) {
            this.form.led_check.total_time = moment(
              this.form.led_check.stop_time
            ).diff(moment(this.form.led_check.start_time), 'seconds')
            this.totalTime += this.form.led_check.total_time
          }
          if (this.form.temperature_check) {
            this.form.temperature_check.total_time = moment(
              this.form.temperature_check.stop_time
            ).diff(moment(this.form.temperature_check.start_time), 'seconds')
            this.totalTime += this.form.temperature_check.total_time
          }
          if (this.form.voltage_check) {
            this.form.voltage_check.total_time = moment(
              this.form.voltage_check.stop_time
            ).diff(moment(this.form.voltage_check.start_time), 'seconds')
            this.totalTime += this.form.voltage_check.total_time
          }
          if (this.form.acc_verify) {
            this.form.acc_verify.total_time = moment(
              this.form.acc_verify.stop_time
            ).diff(moment(this.form.acc_verify.start_time), 'seconds')
            this.totalTime += this.form.acc_verify.total_time
          }
          if (this.form.accelerometer_calibration) {
            this.form.accelerometer_calibration.total_time = moment(
              this.form.accelerometer_calibration.stop_time
            ).diff(
              moment(this.form.accelerometer_calibration.start_time),
              'seconds'
            )
            this.totalTime += this.form.accelerometer_calibration.total_time
          }
          if (this.form.fall_detection) {
            this.form.fall_detection.total_time = moment(
              this.form.fall_detection.stop_time
            ).diff(moment(this.form.fall_detection.start_time), 'seconds')
            this.totalTime += this.form.fall_detection.total_time
          }
          if (this.form.production_check) {
            this.form.production_check.total_time = moment(
              this.form.production_check.stop_time
            ).diff(moment(this.form.production_check.start_time), 'seconds')
            this.totalTime += this.form.production_check.total_time
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    share() {
      this.$refs.shareDialog.openDialog()
    }
  }
}
</script>
